export default function device() {
    let device = {};
    let ua = navigator.userAgent;
    let android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    let ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    let iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);

    device.ios
        = device.android
        = device.iphone
        = device.ipad
        = device.androidChrome
        = device.weixin
        = device.weibo
        = device.beisenApp
        = device.apiCloud
        = device.upaasApp
        = device.upaasAppVersion
        = device.titaVersion
        = false;

    // Android
    if (android) {
        device.os = 'android';
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
        if(ua.toLowerCase().match(/upaasapp\/([\d.]+)/)) {
            device.upaasAppVersion = ua.toLowerCase().match(/upaasapp\/([\d.]+)/)[1];
        }
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
        if(ua.toLowerCase().match(/upaasapp\/([\d.]+)/)) {
            setTimeout(() => {
                if(window.api) {
                    device.upaasAppVersion = window.api && window.api.appVersion || ''; //|| ua.toLowerCase().match(/upaasapp\/([\d.]+)/)[1];
                    if(device.upaasAppVersion === '') {
                        console.log('api.appVersion没有生效');
                    }
                }
            },500);
        }
    }
    // iOS
    if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, '.');
        device.iphone = true;
    }
    if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, '.');
        device.ipad = true;
    }
    if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
        device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
        if (device.osVersion.split('.')[0] === '10') {
            device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
        }
    }

    device.weixin = !!ua.match(/MicroMessenger/i);//判断是否微信平台
    device.weibo = !!ua.match(/Weibo/i); //判断是否微博平台
    device.beisenApp = !!ua.match(/BeisenApp/i) && !ua.match(/Apicloud/i);
    device.apiCloud = ua.toLowerCase().match(/apicloud/i);
    device.titaApp = ua.toLowerCase().match(/tita/i);
    device.upaasApp = ua.toLowerCase().match(/upaasapp/i);

    device.dingTalk = !!ua.match(/DingTalk/i);

    if(device.titaApp) {
        const regArr = ua.toLowerCase().match(/tita\/(\d+\.\d+\.\d+)/);
        if(regArr) {
            device.titaVersion = regArr[1];
        }
    }
    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
        let osVersionArr = device.osVersion.split('.');
        device.minimalUi = !device.webView &&
        (ipod || iphone) &&
        (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
        document.querySelectorAll('meta[name="viewport"]').length > 0 && document.querySelector('meta[name="viewport"]').getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Check for status bar and fullscreen app mode
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;
    device.statusBar = false;
    if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
        device.statusBar = true;
    } else {
        device.statusBar = false;
    }

    // Classes
    let classNames = [];

    // Pixel Ratio
    device.pixelRatio = window.devicePixelRatio || 1;
    classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio));
    if (device.pixelRatio >= 2) {
        classNames.push('retina');
    }

    // OS classes
    if (device.os) {
        classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'));
        if (device.os === 'ios') {
            let major = parseInt(device.osVersion.split('.')[0], 10);
            for (let i = major - 1; i >= 6; i--) {
                classNames.push('ios-gt-' + i);
            }
        }

    }
    // Status bar classes
    // if (device.statusBar) {
    //     classNames.push('with-statusbar-overlay');
    // }
    // else {
    //     $('html').removeClass('with-statusbar-overlay');
    // }

    // Add html classes
    // if (classNames.length > 0) $('html').addClass(classNames.join(' '));

    device.screenHeight = window.screen.height;//判断屏幕高度;
    device.screenWidth = window.screen.width;//判断屏幕宽度;

    const iosItalent = device.upaasApp && device.apiCloud;
    const androidItalent = device.upaasApp && device.android;
    const iosTita = device.titaApp &&  device.apiCloud;
    const androidTita = device.titaApp && device.android && device.titaVersion >= '11.0.4';

    device.BSAndroidApp = androidItalent || androidTita;
    device.BSApiCloudApp = iosItalent || iosTita;
    device.BSApp = iosItalent || androidItalent || iosTita || androidTita;

    device.customApp = device.dingTalk || device.weixin;

    // Export object
    return device;
}



// WEBPACK FOOTER //
// ./src/components/util/device.js